import PropTypes from 'prop-types';
export default {
  sponsorship: PropTypes.shape({
    localities: PropTypes.shape({
      regions: PropTypes.arrayOf(PropTypes.number),
      districts: PropTypes.arrayOf(PropTypes.number),
      divisions: PropTypes.arrayOf(PropTypes.number),
      postcodes: PropTypes.arrayOf(PropTypes.number)
    }),
    enquirySection: PropTypes.shape({
      headingCopy: PropTypes.string,
      headingColour: PropTypes.string,
      bodyCopy: PropTypes.string,
      bodyCopyColour: PropTypes.string,
      buttonCopy: PropTypes.string,
      buttonColour: PropTypes.string,
      disclaimerCopy: PropTypes.string,
      disclaimerColour: PropTypes.string,
      destinationURL: PropTypes.string,
      backgroundColour: PropTypes.string,
      logo: PropTypes.shape({
        imageURL: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number
      })
    })
  })
};